import { useMutation } from '@tanstack/react-query';
import { User } from '../../@types';
import { axiosInstance } from '../../utils';

interface SearchUserPayload {
  name?: string;
  page?: number;
  pageSize?: number;
}

interface PaginatedUsersResponse {
  items: User[];
  total: number;
  page: number;
  pageSize: number;
}

const getAllUsers = async (payload: SearchUserPayload): Promise<PaginatedUsersResponse> => {
  const res = await axiosInstance.get('/api/users/search-users', { params: payload });
  return res.data;
};

export function useGetAllUsers() {
  return useMutation((payload: SearchUserPayload) => getAllUsers(payload), {
    onSuccess: (data) => data,
  });
}
